









import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { CONTRACTS, WindowsServiceContract } from '@/core/contracts';
import { Tree, TreeConfig } from './types';

@Component
export default class TreeOptions extends Vue {
    @Prop() public tree?: Tree;

    @Inject(CONTRACTS.WindowsService) public windowsService?: WindowsServiceContract;

    public updated() {
        Vue.set(this.treeOption, 'haveFilters', this.treeOption.haveFilters);
    }

    public get treeOption(): TreeConfig {
        const { tree } = this;
        return tree ? tree.option() : {};
    }

    public resetFilters() {
        this.tree!.clearFilter();
    }

    public setupTreeGroups() {
        // the only way to hide group panel is to hide DOM element
        // because with disabled group panel DX will not load groups from stored layout.
        const instance = this.tree;
        const gridElement = (instance as any)._$element[0] as HTMLElement;
        const headerPanelElement = gridElement!.querySelector('.dx-treelist-header-panel') as HTMLElement;
        const toolbarItemElement = headerPanelElement!.querySelector('.dx-toolbar-item-content') as HTMLElement;
        const style = window.getComputedStyle(headerPanelElement);
        headerPanelElement.style.display = style.display === 'none' ? 'inherit' : 'none';
        toolbarItemElement.style.lineHeight = 'normal';
    }

    public setupTreeColumns() {
        const { treeOption: { columnChooser }, tree } = this;
        if (columnChooser && columnChooser.enabled) {
            tree!.showColumnChooser();
        }
    }

    public resetTreeLayout() {
        const { windowsService, tree, $options } = this;
        const { l: localizeFilter } = $options.filters!;

        windowsService!
            .showDialog(
                localizeFilter('ResetTreeSettingsDialog'),
                [
                    { id: 1, caption: localizeFilter('DialogYes') },
                    { id: 2, caption: localizeFilter('DialogCancel') },
                ],
            ).then((id) => {
                if (id === 1 && tree) {
                    tree.state({});
                    tree.repaint();
                    tree.refresh();
                }
            });
    }
}
